import compileSymbols from '~/utils/compileSymbols';

var types = [
  'ADD_ART',
  'AD_ACCEPT',
  'ART_BROWSE',
  'AD_ART_SWAP',
  'AD_EDIT_MESSAGE',
  'AD_ENTRY_DECISION',
  'AD_LAYOUTS',
  'AD_NO_TEXT',
  'AD_DESKTOP_PROMO',
  'AD_DESKTOP_SELECT',
  'AD_SKIP_TEXT',
  'ADD_COMPLEMENT',
  'ADD_DESIGN',
  'ADD_ITEMS',
  'ADD_ITEMS_CLOSE',
  'ADD_ITEMS_COLOR_CLOSE',
  'ADD_ITEMS_COLOR',
  'ADD_ITEMS_PICK_STYLE',
  'ADD_ITEMS_QUOTE',
  'ADD_ITEMS_SELECT_COLOR',
  'ADD_ITEMS_BROWSE_MORE',
  'ADD_TEXT',
  'ART_CLOSE',
  'ART_PALETTE',
  'ART_SWAP',
  'ART_COLORS',
  'ART_CHANGE_COLOR',
  'ART_RESET_COLOR',
  'ALIGN_MENU',
  'ART_TOOLS',
  'BUY_FORM',
  'BUY_NOW_CTA_TEST',
  'BUY_WITH_GOF',
  'BUY_WITH_GOF_QUOTE_START',
  'BUY_WITH_GOF_QUOTE_COMPLETE',
  'CANCEL_AD_LEAVE',
  'CHANGE_PRODUCT_COLOR_START',
  'CHANGE_PRODUCT_START',
  'CHANGE_TEXT_EFFECT',
  'CHANGE_TEXT_OUTLINE',
  'CHANGE_TEXT_OUTLINE_COMPLETE',
  'CHAT',
  'COLOR_CTA_CLICK',
  'CURRENT_PATH_PAGE_VIEW_TAG',
  'DEFAULT_BLANK_TEST',
  'DESIGN_TOOLS_OPEN',
  'DESIGN_TOOLS_SELECT',
  'DESIGN_TOOLS_CLOSE',
  'DESIGN_WITH_PRO',
  'DISCONTINUED_PRODUCT',
  'DISCONTINUED_PRODUCT_COLOR',
  'ENTER_POSTAL_CODE',
  'EMBROIDERY_MODAL_TEST',
  'FONT_BROWSE_SEE_MORE',
  'FUNDRAISING_NAVIGATION',
  'FUNDRAISING_CAMPAIGN_CLOSED',
  'FUNDRAISING_MODE_WELCOME',
  'FUNDRAISING_MODE_GOALS',
  'HELP_CALL',
  'HELP_EMAIL',
  'HELP_FEEDBACK',
  'HELP_MENU',
  'HELP_VISIT_FULL_SITE',
  'HIDE_CONTEXTUAL_TOOLS',
  'LAB_FROM_AD',
  'LOAD_WITHOUT_DESIGN',
  'ORDER_MORE',
  'ORDER_MORE_ADD_STYLES',
  'ORDER_MORE_ADD_ITEMS_ADD_STYLES',
  'ORDER_MORE_STYLES_ADDED',
  'ORDER_MORE_QUOTE_ADD_STYLES',
  'NAMES_AND_NUMBERS',
  'NAMES_AND_NUMBERS_COLORS',
  'NAMES_AND_NUMBERS_CLOSE',
  'NAMES_AND_NUMBERS_GET_STARTED',
  'NAMES_AND_NUMBERS_POSITION',
  'NAMES_AND_NUMBERS_REDIRECT',
  'NAMES_AND_NUMBERS_LIST',
  'NAMES_AND_NUMBERS_ALERT',
  'NAMES_AND_NUMBERS_COMPLETE',
  'NAMES_AND_NUMBERS_EDIT',
  'NDX_BREAKPOINT',
  'NDX_START',
  'NEXT_GOF',
  'NEXT_FULL',
  'NEXT_FUNDRAISING',
  'NEXT_FUNDRAISING_GOALS',
  'NEXT',
  'PRINT_THIS',
  'PRO_GATE',
  'PRODUCT_COLOR_CHANGE_ACCEPTED',
  'PRODUCT_COLOR_CHANGE_CANCELLED',
  'PRODUCT_COLOR_CHANGED',
  'PRODUCT_COLOR_NOT_CHANGED',
  'PRODUCT_COLOR_TAB_CHANGED',
  'PRODUCT_COLOR_TOGGLE_CHANGED',
  'PRODUCT_COLOR',
  'PRODUCT_CATALOG',
  'PRODUCT_DETAILS',
  'PRODUCT_PRINT_AREA',
  'PRODUCT_SUMMARY',
  'PRODUCT_SUMMARY_CAROUSEL',
  'PRODUCT_SUMMARY_TAG',
  'PRODUCT_WELCOME',
  'QUOTE_BLANK_DESIGN',
  'QUOTE_FORM',
  'QUOTE_FORM_POSTAL_CODE_CHANGE',
  'QUOTE_FORM_START',
  'QUOTE_STATE_CHANGE',
  'QUOTE_WCIBMO',
  'REAL_TIME_PRICE_CHANGE',
  'REAL_TIME_PRICE_QUANTITY_CHANGE',
  'REAL_TIME_PRICING_TEST',
  'RESIZE',
  'SAVE_FORM',
  'SAVE_ADD_CART_ATTEMPT',
  'SAVE_ADD_CART',
  'SELECT_FONT',
  'SHARE_FACEBOOK',
  'SHARE_EMAIL',
  'SHARE_LINK',
  'SHARE_PINTEREST',
  'SHARE_TWITTER',
  'SHOPPING_CART_CANCEL',
  'SHOPPING_CART_STATUS',
  'SINGLES_TOGGLE_TEST',
  'SLEEVE_ERROR_FUNDRAISING',
  'SLEEVE_ERROR_GOF',
  'STRIKE_PRICING',
  'SINGLES_CONTENT_ALERT_TEST',
  'SINGLES_PRICING_MESSAGE_TEST',
  'SLEEVE_PRINT',
  'SLEEVE_PRINT_ACTIONS',
  'SLEEVE_PRINT_MODAL',
  'SLEEVE_PRINT_NO_SLEEVE_IMAGE_SELECTED_PRODUCT',
  'SLEEVE_PRINT_PRICE_INFO',
  'SLEEVE_PRINT_REMOVE_DESIGN',
  'SLEEVE_PRINT_UNDO_REMOVE_DESIGN',
  'START_POSTAL_CODE_UPDATE',
  'SUBTLETY_CHECK',
  'SUPPRESS_EMAIL_VALIDATION',
  'SWAP_PRODUCT_WARNING',
  'TEST_INTO_DECO_FLEX',
  'TEXT_EDIT',
  'TEXT_EFFECTS_BROWSE',
  'TEXT_EFFECT_DONE',
  'TEXT_EFFECT_INTENSITY',
  'TEXT_FONT_BROWSE',
  'TEXT_FONT_BROWSE_CATEGORIES',
  'TEXT_OUTLINE_INTENSITY',
  'TEXT_OUTLINE_COLOR',
  'TEXT_OUTLINE_ON',
  'TEXT_OUTLINE_OFF',
  'TEXT_PALETTE',
  'TEXT_START',
  'TEXT_SEARCH',
  'TEXT_TOOLS',
  'UPDATE_EXTERNAL_EVENT',
  'UPLOAD',
  'UPLOAD_ADD',
  'UPLOAD_START',
  'UPLOAD_BROWSE',
  'UPLOAD_CHANGE_COLOR',
  'UPLOAD_CLOSE_TOOLS',
  'UPLOAD_CONTACT_US',
  'UPLOAD_DRAG',
  'UPLOAD_COLOR_REMOVAL',
  'UPLOAD_LEARN_MORE',
  'UPLOAD_RECENT',
  'UPLOAD_RESET_COLOR',
  'UPLOAD_SUCCESS',
  'UPLOAD_TOGGLE_BACKGROUND',
  'UPLOAD_TOGGLE_PRODUCT_COLOR',
  'UPLOAD_TOOLS',
  'UPLOAD_OR_BROWSE_ART',
  'VIEW_ALL_FONT_CATEGORIES',
  'WTO_OPTION_LOAD',
  'WTO_OPTION_CONFIRM_BULK',
  'WTO_OPTION_UPDATE',
  'WELCOME',
  'WELCOME_BACK_CONTINUE',
  'WELCOME_BACK_NEW',
  'WELCOME_BACK',
  'ZOOM_IN',
  'ZOOM_OUT'
];

export default compileSymbols(types, 'analytics');
